<div class="page-container">
	<div class="background-wrapper">
		<app-particle-background></app-particle-background>
	</div>

	<div class="content-wrapper">
		<div class="error-card animate-enter">
			<div class="visual-header">
				<mat-icon class="icon-faded">grid_off</mat-icon>
				<h1 class="error-code">404</h1>
			</div>

			<div class="text-content">
				<h2>Window Not Found</h2>
				<p>The page you are looking for doesn't exist. It may have been moved or the link you followed may be incomplete.</p>
			</div>

			<div class="actions">
				<button mat-stroked-button class="back-btn" (click)="goBack()">
					<mat-icon>arrow_back</mat-icon>
					Go Back
				</button>
			</div>
		</div>
	</div>
</div>
